module.exports = __webpack_public_path__ + "img/es_spa.b8c75e82.png";